var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHkd = function SvgHkd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z",
    fill: "#ED4C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.333 8.6c.234-.6.8-.7 1.1-1.467.134-.333-.1-1 .034-1.333.3-.767 1.066-.633 1.066-.633-1.366-.5-2.9.2-3.4 1.533s.2 2.833 1.567 3.3c-.367-.4-.567-.867-.367-1.4Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.467 6.734a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6Z",
    fill: "#ED4C5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 9.933c-.5-.4-.433-.966-1.1-1.466-.3-.234-1-.2-1.3-.434-.667-.5-.267-1.2-.267-1.2-.9 1.134-.7 2.767.467 3.634 1.133.866 2.8.666 3.7-.434-.533.2-1.033.234-1.5-.1Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 9.467a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6Z",
    fill: "#ED4C5C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.167 11.4c-.534.367-1.067.1-1.767.567-.3.2-.5.866-.8 1.066-.7.467-1.267-.1-1.267-.1.8 1.2 2.467 1.5 3.667.7 1.2-.8 1.533-2.4.733-3.6.034.567-.1 1.034-.566 1.367",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 12.767c.1-.134.3-.167.434-.067.133.1.166.3.066.434-.1.133-.3.166-.433.066a.316.316 0 0 1-.067-.433Z",
    fill: "#ED4C5C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.867 10.967c.166.6-.234 1.033 0 1.833.1.333.666.733.766 1.1.234.8-.5 1.133-.5 1.133 1.4-.4 2.2-1.833 1.8-3.2-.4-1.366-1.866-2.166-3.266-1.766.6.1 1.033.333 1.2.9",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 12.733a.316.316 0 0 1 .067-.433.316.316 0 0 1 .433.067c.1.133.067.333-.067.433-.166.133-.333.1-.433-.067Z",
    fill: "#ED4C5C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.967 9.233c.666.034.933.534 1.766.567.367 0 .934-.4 1.3-.4.834.033.934.8.934.8.066-1.433-1.1-2.633-2.534-2.667C10.967 7.5 9.767 8.6 9.7 10.033c.3-.5.7-.833 1.267-.8",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.167 8.833c-.167.067-.334-.033-.4-.2-.067-.166.033-.333.2-.4.166-.066.333.034.4.2.066.167-.034.367-.2.4Z",
    fill: "#ED4C5C"
  })));
};
export default SvgHkd;